module.exports = __webpack_public_path__ + "media/images/icons/link-76e33305456e3b83985ad7a95f66615b.svg";